import React from "react";

import { AdSlot } from "./AdSlot";

/**
 * Оборачивает карту ir-блоков шаблона в `AdSlot`.
 *
 * Все шаблоны строят её одинаково — `{1: <блок ir1/>, 2: <блок ir2/>, ...}`, где
 * ключ и есть номер слота. Поэтому подключение к БД сводится к одной обёртке:
 * слот сначала спрашивает кампанию, а прежний JSX шаблона остаётся фолбэком и
 * рисуется, пока кампании нет или она выключена.
 *
 * Отдельная функция, а не правка каждой карты: восемь шаблонов строят её
 * по-разному (разный порядок аргументов, разные компоненты), но результат
 * одинаковый, и различаться в этом месте им незачем.
 */
export function wrapIrSlots(map, { isFull, isDesktop, json }) {
    const wrapped = {};

    for (const position of Object.keys(map)) {
        // json: карта {позиция: тизерный компонент} или null; без него json-место
        // нарисовало бы fallback, а он здесь из бандла.
        const jsonProp = json === undefined ? {} : { json: json ? json[position] || null : null };

        wrapped[position] = (
            <AdSlot
                slot={`ir${position}`}
                isFull={isFull}
                isDesktop={isDesktop}
                fallback={map[position]}
                {...jsonProp}
            />
        );
    }

    return wrapped;
}

export default wrapIrSlots;
